export function reportError(callbacks, error) {
  if (typeof callbacks?.onError !== 'function') return;
  try {
    callbacks.onError(error);
  } catch {
    // Errors in the handler must not replace the original error or recurse.
  }
}

export function notify(callbacks, name, payload) {
  if (typeof callbacks[name] !== 'function') return;
  try {
    return callbacks[name](payload);
  } catch (error) {
    reportError(callbacks, error);
  }
}
